import moment from 'moment';
import { v4 as uuid } from 'uuid';
import { TransportLocation } from '../models/transport-location.model';
import { COLOR_7P_TEAL, getAlertColor, getAlertIcon } from '../utils';
import { TransportAlertType, TransportAlertTypeMap } from '../models/transport-alert-types';

export interface TransportAlarm {
  time: number;
  alertType: number;
  info: string;
  location: TransportLocation;
}

export class TransportAlarm {
  id: string;
  point: google.maps.LatLng;
  isValid: boolean;
  date: moment.Moment;
  alertColor: string = COLOR_7P_TEAL;
  alertIcon: string = 'icon-small_solid_package-2';

  constructor(alarm: TransportAlarm) {
    this.id = uuid();

    Object.assign(this, alarm);

    const { location = null, time } = alarm;

    const { lat = null, lng = null, valid = 0 } = location ?? {};

    this.date = moment.unix(time);

    this.point = !lat || !lng ? null : new google.maps.LatLng({ lat, lng });
    this.isValid = Boolean(valid);

    this.alertColor = getAlertColor(alarm.alertType);
    this.alertIcon = getAlertIcon(alarm.alertType);
  }
}
